import { Box, Typography, Avatar } from "@mui/material";

const Topbar = () => {
  return (
    <Box className="bg-white shadow px-6 py-4 flex justify-between items-center">
      <Typography variant="h6">Dashboard</Typography>

      <Avatar sx={{ bgcolor: "black" }}>A</Avatar>
    </Box>
  );
};

export default Topbar;
